import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { SAVED_SEARCHES_QUERY_KEY } from './useSavedSearchesQuery';

interface SaveSavedSearchParams {
	name: string;
	filter: Api.IContactFilterCriteria;
	ownershipFilter?: Api.IOwnershipFilter;
	impersonationContext?: Api.IImpersonationContext;
}

interface UseSaveSavedSearchMutationOptions {
	onSuccess?: (data: Api.ContactSearch) => void;
	onError?: (error: unknown) => void;
}

export function useSaveSavedSearchMutation({ onSuccess, onError }: UseSaveSavedSearchMutationOptions = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ name, filter, ownershipFilter, impersonationContext }: SaveSavedSearchParams) => {
			return userSession.webServiceHelper.callAsync<Api.ContactSearch>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'contactSearch',
					impersonationContext,
				}),
				'POST',
				{
					name,
					filter,
					ownershipFilter,
				}
			);
		},
		onSuccess: data => {
			// Invalidate the saved searches list query
			queryClient.invalidateQueries({
				queryKey: [SAVED_SEARCHES_QUERY_KEY],
			});
			onSuccess?.(data);
		},
		onError: error => {
			onError?.(error);
		},
	});
}
